import serverURL from "../../config/serverConfig"
import { useEffect, useState, useContext } from "react"
import { userContext } from '../../contexts/userContext';
import { useUserClients } from "../../hooks/db";

// import { getProjectList } from "../scripts/getProjects"
import NewProjectForm from "./NewProjectForm"

const CreateProject = () => {

    const user = "jaykurzweil"
    const user_id = useContext(userContext);
    const userClients = useUserClients(user_id[0]); 

    let projectList = []
    const [isUploaded, setUploaded] = useState(false);
    const [projectID, setProjectID] = useState();


    //load project list
    // useEffect( () => {
    //     console.log(serverURL + "data/" + user + "/projects/projectList.json")
    //     fetch(serverURL + "data/" + user + "/projects/projectList.json")
    //         .then(response => response.json())
    //         .then((jsonData) => {
    //             projectList = jsonData
    //             console.log(projectList.length)
    //         })
    //         .catch((error) => {
    //             //console.log(error)
    //             console.log("No Project List Found")
    //         })
    // },[])

    //add new project to list - callback
    const addNew = (details) => {
        // alert(JSON.stringify(details, null, 2));
        // details.status = "not started"
        // projectList.push(details)
        // projectList[projectList.length-1].id = projectList.length
        // console.log(details)
        // let newID = details.id
        console.log(details.client)
        const clientDetails = details.client.split("^");
        console.log("client deatails: ", clientDetails)

        fetch(serverURL+"createProject", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                },
            body: JSON.stringify({
                user_id: user_id[0],
                client: clientDetails[0],
                //client_id: details.client_id,
                title: details.title,
                // type: details.type,
                // num_of_songs: details.songs,
                description: details.description,
                start_date: details.startDate,
                due_date: details.dueDate,
                status: details.status,
                fee: details.fee,
                paid: details.paid,
                client_id: clientDetails[1] ?? details.client_id,
                //notes: details.notes,

            }),
        })
        .then((response) => response.json())
        .then((data) => {
            let id = data[0].project_id
            id = Number(id);
            console.log(data[0].project_id);
            console.log(id)
            setUploaded(true)
            setProjectID(id)
        })
        .catch((error) => {
            console.log("Error creating project: " + error)
        });
    }

    useEffect( () => {
        //console.log(serverURL + "data/" + user + "/projects/projectList.json")
        fetch(serverURL+"createNote", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                },
            body: JSON.stringify({
                project_id: projectID
                //notes: details.notes,

            }),
        })
        .then((response) => response.json())
        .then((data) => {
            //console.log(data);
            setUploaded(true)
            //setProjectID(data.project_id)
        })
        .catch((error) => {
            console.log(error)
        });

        fetch(serverURL+"createToDoList", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                },
            body: JSON.stringify({
                project_id: projectID
                //notes: details.notes,

            }),
        })
        .then((response) => response.json())
        .then((data) => {
            //console.log(data);
            //setUploaded(true)
            //setProjectID(data.project_id)
        })
        .catch((error) => {
            console.log(error)
        });
    },[projectID])


    return (
        <div>
            <h3>Create Project</h3>
            <NewProjectForm submit={addNew} clients={userClients}/>
        </div>
    )
}

export default CreateProject